// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import iView from 'view-design'
import i18n from '@/locale'
import config from '@/config'
import importDirective from '@/directive'
import { directive as clickOutside } from 'v-click-outside-x'
import installPlugin from '@/plugin'
import 'view-design/dist/styles/iview.css'
import { getToken } from './libs/util'
import './index.less'
import '@/assets/icons/iconfont.css'
import TreeTable from 'tree-table-vue'
import VOrgTree from 'v-org-tree'
import 'v-org-tree/dist/v-org-tree.css'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
// 实际打包时应该不引入mock
/* eslint-disable */
// if (process.env.NODE_ENV !== 'production') require('@/mock')
import 'vue-resize/dist/vue-resize.css'
import VueResize from 'vue-resize'
Vue.use(VueResize)

const token = getToken()
Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(Viewer,{
  defaultOptions: {
    zIndex: 1100
  }
})
Vue.use(TreeTable)
Vue.use(VOrgTree)
/**
 * @description 注册admin内置插件
 */
installPlugin(Vue)
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
/**
 * 注册指令
 */

const userInfo = JSON.parse(localStorage.getItem('userInfo'))
if(userInfo){
  store.commit('setUserInfo',userInfo)
}
importDirective(Vue)
Vue.directive('clickOutside', clickOutside)
if(token)store.dispatch('addRouterList')
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: (h) => h(App)
})
